import type { StringMap } from 'corgi-types';
import { SignupFlow } from 'corgi-types';

import { Header } from '@local-types/enums/header';

export const isRegularOrDigitalCheckoutFlow = (userFlow: SignupFlow) =>
  [SignupFlow.Checkout, SignupFlow.GiftCardCheckout].includes(userFlow);

export const isDigitalCheckout = (userFlow: SignupFlow) => userFlow === SignupFlow.GiftCardCheckout;

export const isReferralSignUpFlow = (userFlow: SignupFlow, code?: string | string[]) =>
  Boolean(userFlow === SignupFlow.Referral && code);

const ALLOWED_QUERY_FLOWS = [
  SignupFlow.Cart,
  SignupFlow.Contact,
  SignupFlow.Checkout,
  SignupFlow.Wishlist,
  SignupFlow.CartHomeClub,
  SignupFlow.ContentHomeClub,
  SignupFlow.GiftCardCheckout,
  SignupFlow.Referral,
  SignupFlow.ReferralLanding,
];

export const getUserFlow = (userFlow: string, headers: StringMap<string>): SignupFlow => {
  if (ALLOWED_QUERY_FLOWS.includes(userFlow as SignupFlow)) {
    return userFlow as SignupFlow;
  }

  const originalUrl = headers[Header.OriginalUrl];
  const redirectedFrom = headers[Header.RedirectedFrom];

  const isGiftCardCheckoutFlow =
    /giftCardCheckout/.test(redirectedFrom as string) ||
    /giftcard\/checkout\/new/.test(originalUrl as string);
  const isCheckoutFlow =
    /checkout/.test(redirectedFrom as string) || /checkout/.test(originalUrl as string);

  if (isGiftCardCheckoutFlow) {
    return SignupFlow.GiftCardCheckout;
  } else if (isCheckoutFlow) {
    return SignupFlow.Checkout;
  }

  if (originalUrl) {
    // TODO: Should be improved in https://home24.atlassian.net/browse/FP-4569

    const myAccountUrls = ['/login', '/registration', '/resetpassword'];

    if (myAccountUrls.some(url => originalUrl.includes(url))) {
      return SignupFlow.MyAccount;
    }
  }

  return SignupFlow.Redirect;
};
